import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { EventsEntity, EventsItemEntity, ItemsLinksEntity, LinkEntity, ModuleWebsiteDescriptiveTable } from '../../interfaces'
import { Router } from '@angular/router'

@Component({
  selector: 'dmmp-descriptive-event-table',
  templateUrl: './descriptive-event-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DescriptiveEventTableComponent {
  @Input() identifier: string
  @Input() module: ModuleWebsiteDescriptiveTable
  @Input() layout: any
  @Input() pathTo: string
  @Output()  redirectPage: EventEmitter<void> = new EventEmitter<void>()


  constructor(private router: Router) { }

  dynamicGoTo(link: LinkEntity, itemLinks: EventsEntity) {
    if (itemLinks?.is_topic) {
      this.router.navigate([this.pathTo], {
        queryParams: {topic: this.layout?.topic[0]?.id }
      })
      this.redirectPage.emit()
      return
    }
    if (itemLinks?.is_contact && this.layout?.email) {
      window.open(  `mailto:${this.layout?.email}`)
      return
    }
    if (link?.name !== '') {
      window.open(link?.link, '_blank')
    }
  }
}
